<style lang="scss" scoped>
.report-info {
	table {
		width: 100%;
		text-align: left;
		p {
			line-height: 0px;
		}
	}
	&__footer {
		margin-top: 30px;
	}
}
</style>

<template lang="pug"> 
	.report-info
		.main
			table.data
				tr
					td Status
					td {{ this.report.status | capitalize}}
				tr
					td Run at
					td {{ this.report.run_at | standard_datetime }}
				tr
					td Created at
					td {{ this.report.created_at | standard_datetime }}
				tr
					td Query Count
					td {{ this.report.query_count || 'N/A' }}
				tr
					td Query Time
					td {{ this.report.query_time || 'N/A'  }}
		.report-info__footer(v-can:run-reports)
			el-button(v-if="showButton && permitted", type="primary", @click="handleClick") Re-run report
			el-button(v-else-if="permitted", type="danger", :disabled="true") Only failed reports can be rerun
</template>

<script>
import gql from "graphql-tag";

export default {
	props: {
		report: {
			type: Object,
			required: true
		}
	},

	data() {
		return {
			userInput: null
		};
	},

	methods: {
		handleClick() {
			this.$apollo.mutate({
				mutation: gql`
					mutation RunReports($school_id: ID!, $report_ids: String!, $queue: String, $run_at: String) {
						RunReports(school_id: $school_id, report_ids: $report_ids, queue: $queue, run_at: $run_at)
					}
				`,
				variables: {
					school_id: this.$route.params.school,
					report_ids: this.report.id,
					queue: "urgent"
				},
				update: (store, returned) => {
					if (returned.data.RunReports) {
						this.$message.success("Report has been queued");
						this.$bus.emit("reports-fired");
						this.$vuedals.close();
					} else {
						this.$message.error("Report could not be queued");
					}
				}
			});
		}
	},

	computed: {
		showButton() {
			switch (this.report.status) {
				case "failed":
				case "exception":
				case "failing":
				case "deleted":
					return true;
				default:
					return false;
			}
		},
		permitted() {
			return this.report.permitted
		},
		readyToConfirm() {
			return this.userInput === this.value;
		}
	}
};
</script>
